import { Container, Typography, Box, Link } from "@mui/material";

function Privacy() {
  return (
    <>
      <Container maxWidth="md">
        <Typography variant="h4" component="h1" gutterBottom>
          Privacy Policy
        </Typography>
        <Typography variant="h6">Last updated: June 1, 2026</Typography>

        <Box sx={{ my: 2 }}>
          <Typography variant="body1" paragraph>
            This Privacy Policy describes how KB Quick ("we," "us," or "our")
            collects, uses, and discloses your information when you use our
            mobile application and web portal (the "Service").
          </Typography>
        </Box>

        <Typography variant="h5" component="h2" gutterBottom>
          Information We Collect
        </Typography>
        <Typography variant="body1" paragraph>
          We collect information you provide directly to us when you create an
          account, such as:
        </Typography>
        <ul>
          <li>
            <Typography>
              Name and Email Address (via Firebase Authentication)
            </Typography>
          </li>
          <li>
            <Typography>Organization Name (if applicable)</Typography>
          </li>
        </ul>
        <Typography variant="body1" paragraph>
          We also collect information you generate while using the Service:
        </Typography>
        <ul>
          <li>
            <Typography>
              <strong>Test Data:</strong> For each assessment you enter a Case
              ID (required) and select an organism, host species, specimen type,
              and clinical indication from built-in lists. You may also add
              free-text Notes. Case IDs are user-supplied reference values that
              link results to your own records; KB Quick does not request or
              collect patient names or other patient-identifying information.
            </Typography>
          </li>
          <li>
            <Typography>
              <strong>Images:</strong> Photographs of culture plates you upload
              via the app. This data is stored securely in Firebase Storage.
            </Typography>
          </li>
          <li>
            <Typography>
              All metadata and assessment results are stored in our Firebase
              Firestore database.
            </Typography>
          </li>
          <li>
            <Typography>
              <strong>Support &amp; Feedback:</strong> Messages you submit
              through the in-app support or feedback forms, stored so we can
              respond and for record-keeping.
            </Typography>
          </li>
        </ul>
        <Typography variant="body1" paragraph>
          We also automatically collect technical and usage data through Google
          Firebase services:
        </Typography>
        <ul>
          <li>
            <Typography>
              Product interaction and usage data (Firebase Analytics).
            </Typography>
          </li>
          <li>
            <Typography>
              Crash reports and performance diagnostics (Firebase Crashlytics
              and Performance Monitoring).
            </Typography>
          </li>
          <li>
            <Typography>
              Device identifiers, used for security and abuse prevention
              (Firebase App Check) and for analytics.
            </Typography>
          </li>
        </ul>

        <Typography variant="h5" component="h2" gutterBottom>
          How We Use Your Information
        </Typography>
        <Typography variant="body1" paragraph>
          We use the information we collect to:
        </Typography>
        <ul>
          <li>
            <Typography>Provide, maintain, and improve our Service.</Typography>
          </li>
          <li>
            <Typography>Authenticate users and manage accounts.</Typography>
          </li>
          <li>
            <Typography>
              Allow organizational administrators to manage their users.
            </Typography>
          </li>
          <li>
            <Typography>
              Respond to your comments, questions, and requests.
            </Typography>
          </li>
        </ul>

        <Typography variant="h5" component="h2" gutterBottom>
          Data Retention
        </Typography>
        <Typography variant="body1" paragraph>
          We retain your data for as long as your account is active. You may
          request deletion of your account and associated data through the app's
          Support page or by contacting us directly.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom>
          Third-Party Services
        </Typography>
        <Typography variant="body1" paragraph>
          We use Google Firebase for authentication, data storage, hosting,
          analytics, crash reporting, performance monitoring, and app security
          (App Check). Their privacy policy can be found at{" "}
          <Link
            href="https://firebase.google.com/support/privacy"
            target="_blank"
            rel="noopener noreferrer"
          >
            firebase.google.com/support/privacy
          </Link>
          .
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom>
          Sharing of Information
        </Typography>
        <Typography variant="body1" paragraph>
          We do not share your personal information with third parties except as
          required by law. Data within an organization is visible to the
          administrator of that organization.
        </Typography>

        <Typography variant="h5" component="h2" gutterBottom>
          Contact Us
        </Typography>
        <Typography variant="body1" paragraph>
          If you have any questions about this Privacy Policy, please contact us
          at:{" "}
          <Link href="mailto:kbq_admin@epi-insight.com">
            kbq_admin@epi-insight.com
          </Link>
          .
        </Typography>
      </Container>
    </>
  );
}

export default Privacy;
